export const getTrackRefId = (trackRef) => {

    if (!trackRef) return null

    return trackRef?.participant?.sid + (trackRef?.publication?.trackSid ?? "")
}